import { Component } from 'react'
class SectionAbout extends Component {

    state= {
        content: [
            { 
                emoji: "🔍",
                name: "Explorer",
                link: ["https://explorer.bitquery.io/bsc/token/0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c"],
                linkTitle: ["Bitquery"],
                indications:""
            },
            { 
                emoji: "📃",
                name: "Contract",
                link: ["https://bscscan.com/address/0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💲",
                name: "Token",
                link: ["https://bscscan.com/token/0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💸",
                name: "Trade",
                link: ["https://dex.guru/token/0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c-bsc",
                        "https://pancakeswap.finance/swap?outputCurrency=0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c"],
                        linkTitle: ["dex.guru","PancakeSwap"],
                indications:`Add address "0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c" to "Select a token" and set SLIPPAGE 12% in the options.`
            },
            { 
                emoji: "🧫",
                name: "Liquidity pool",
                link: ["https://exchange.pancakeswap.finance/#/add/BNB"],
                linkTitle: ["PancakeSwap"],
                indications: `Add  address "0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c" to "Select a currency".`
            },
            { 
                emoji: "📈",
                name: "Chart",
                link: ["https://charts.bogged.finance/?token=0x8f4fc37BFf97e6e7fD4355a5df76A486Ac1e2E1c",
                        "https://poocoin.app/tokens/0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c"],
                        linkTitle: ["BoggedFinance","PooCoin"],
                indications:""
            },
            { 
                emoji: "🔥",
                name: "Token burn",
                link: ["https://bscscan.com/tx/0x7352ef03343d1a737f20674e7434eb85af4b1f666717288e9e866269a193a1c1"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "🔒",
                name: "Liquidity lock",
                link: ["https://app.unicrypt.network/amm/pancake-v2/pair/0xbcE2a84CED47b7f29c5a29e4d158294772cbA272"],
                linkTitle: ["UniCrypt"],
                indications:""
            },
            { 
                emoji: "🚀",
                name: "Roadmap",
                link: ["https://www.notion.so/7397a1c01e3b40d2889cba833a35f4fa?v=682b420b3c344f89a126c2df86506360"],
                linkTitle: ["Notion"],
                indications:""
            },
            { 
                emoji: "🧾",
                name: "Listing",
                link: ["https://www.livecoinwatch.com/price/Catena-CTENA",
                        "https://coinsniper.net/coin/1015",
                        "https://coincodex.com/crypto/catena/",
                        "https://freshcoins.io/AQ00T48feZm2pS2mn96t/coin/catena/ctena",
                        "https://coinvote.cc/coin/CATENA",
                        "https://coinhunt.cc/coin/2135751361",
                        "https://rival.finance/0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c",
                        "https://cointoplist.net/coin/catena"

                    ],
                linkTitle: ["LiveCoinWatch","CoinSniper","CoinCodex","FreshCoins","CoinVote", "CoinHunt","Rival","CoinTopList"],
                indications:""
            },
            { 
                emoji: "📢",
                name: "Proposal",
                link: ["https://catenaprotocol.kampsite.co/"],
                linkTitle: ["Kampsite"],
                indications:""
            },
        ]
    }

     copyToClipboard = (e) => {
        const el = document.createElement('textarea');
        el.value = "0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c";
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        e.target.innerHTML=" Copied! :)";
        setTimeout(() => {
            e.target.innerHTML=" Copy Address";  
        }, 3000);
      };
      
    render () {
        return (
            <div className="section-wrap" id="faq-wrap">
                <p id="faq-title">CTENA</p>
                    
                <div id="intro-buttons">
                {/* <a href="https://dashboard.ctena.finance"><button>Dashboard</button></a>
                <a href="https://stak.ctena.finance"><button>Staking LP </button></a> */}
                <a href="https://vault.ctena.finance"><button>App</button></a>
                <a href="https://pancakeswap.finance/swap?outputCurrency=0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c"><button>Buy</button></a>
                <a href="https://pancakeswap.finance/add/BNB/0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c"><button>Add Liquidity</button></a>
                </div>
                 <div id="info-txt">
                    <p> <span>CTENA Finance </span> is a Decentralized Finance (DeFi) protocol that provide a suite tool for decentralized investments backed by <b>CTENA Token</b>. 
        
                        It is the first token with a Black Hole design that exponentially cuts the total supply in circulation by massive amounts. 
                        CTENA combines this with an innovative Auto-Liquidity feature that increases liquidity of the token rapidly. And finally, 
                        CTENA has massive decentralization on a scale rarely seen in other tokens. Combine these three together and you get a power house token out of the hands of anyone, except the community as a whole.
                        The Black Hole owned over 45% of supply at launch. The Black Hole counts as one of the 
                        wallet holders that 4% of transactions are distributed to. This results in exponential growth of 
                        the black hole and exponential burn of the token supply. At the time of this writing, the black hole 
                        has already grown to 46% percent ownership of the total supply.
                    </p>
                    <p>
                       The CTENA team reserves the possibility to invest in DeFi projects, so to increase the token's value.</p>
                </div>
                <br></br>
                <br></br>
                <div  id="features-wrap">
                <div id="features-row1">
                    <div className="features-item" id="features-item1">
                        <div className="features-item-box">
                            <p className="features-item-logo" id="feat-logo-1">
                            📒
                            </p>
                            <p className="features-item-title">4% Added to liquidity</p>
                            <p className="features-item-description">Auto added to the liquidity pool to locked forever when selling.</p>
                        
                        </div>
                    </div>
                    <div className="features-item" id="features-item2">
                        <div className="features-item-box">
                            <p className="features-item-logo" id="feat-logo-2">
                            ➗
                            </p>
                            <p className="features-item-title">4% Auto distributed to all holders</p>
                            <p className="features-item-description">I will add 0.1 BNB and all the left 49.5% total supply to the pool.</p>
                        </div>
                    </div>
                </div>
                <div id="features-row2">
                    <div className="features-item" id="features-item3">
                        <div className="features-item-box">
                            <p className="features-item-logo" id="feat-logo-3">
                            🔥
                            </p>
                            <p className="features-item-title">45% Burned in the Blackhole</p>
                            <p className="features-item-description">Big black hole + 3% fee = a strong holder gets a valuable reward.</p>
                        </div>
                    </div>
                    <div className="features-item" id="features-item4">
                        <div className="features-item-box">
                            <p className="features-item-logo" id="feat-logo-4">
                            🧍🧍‍♀️🧍‍♂️
                            </p>
                            <p className="features-item-title">100% Community driven</p>
                            <p className="features-item-description">To keep a healthy and consistent grow within our community.</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br>
            <br></br>
                <div id="info-box2">

                
                   

                <div id="info-box2-1">
                
                    <div id="info-col1">
                        <p id="info-subtitle">Tokenomics</p>

                        <div id="info-progress-wrap">
                            <p>Total supply</p>
                            <div className="progress-item">
                            <div className="progress-fill" id="progress-fill-1"></div>
                            <p className="progress-txt" id="progress-txt-1">1,000,000,000,000,000</p>
                        </div>
                            <p>Blackhole</p>
                            <div className="progress-item">
                            <div className="progress-fill" id="progress-fill-2"></div>
                            <p className="progress-txt">45%</p>
                        </div>
                            <p>Liquidity</p>
                            <div className="progress-item">
                            <div className="progress-fill" id="progress-fill-3"></div>
                            <p className="progress-txt">50%</p>
                        </div>
                            
                            <p>Team</p>
                            <div className="progress-item">
                            <div className="progress-fill" id="progress-fill-4"></div>
                            <p className="progress-txt">5%</p>
                        </div>
                        </div>
                    </div>
                    
                    
                    
                    </div>

                </div>
                
              
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                { this.state.content.map( (box, index) => (
                    <div key={index} className="question-box">
                        <p className="question-q"><span className="question-q1">{box.emoji}</span>
                            <span className="question-q2">{box.name}</span>
                            {(box.indications === "")? null : <span class="copy-address-button" onClick={e => this.copyToClipboard(e)}> Copy Address </span>}
                        </p>
                        <div  className="question-boxForButtons">
                            {box.link.map( (link, index) => <a href={link} target="_blank"><button key={index}> {box.linkTitle[index]}</button> </a>)}
                        </div>
                        {(box.indications === "")? null : <p key={index} className="question-indications"> {box.indications}</p>}
                    </div>
                ))
                }
                

                

          

            </div>
  
        )
    }
}

export default SectionAbout
